// extracted by css-extract-rspack-plugin
export default {"lots":"Ta73R3mRs1kTv8J___lots___","lotName":"v0zleKRgd0FU1zel__lotName___"};